













import { Component, Vue } from 'vue-property-decorator';
import { mentoringRoutes } from './router';
import { Menu as InnerMenu } from '@/pages/profile/blocks';
import { Warning } from '@/pages/profile/components';
import { MenuData } from '@/pages/profile/blocks';

@Component({
  components: {
    InnerMenu,
    Warning,
  },
})
export default class Mentoring extends Vue {
  menu: MenuData = mentoringRoutes;

  get isChildren(): boolean {
    const { user } = this.$store.state;
    return user && user.children && user.children.length > 0;
  }

  get isInquiryRoute(): boolean {
    const { name } = this.$route;
    return name === 'profile-inquiry';
  }

  get showPages(): boolean {
    const { isChildren, isInquiryRoute } = this;
    return isChildren || isInquiryRoute;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/Index.vue